import { FC, ChangeEvent, useState } from "react";
import { Field } from "formik";
import { StyleFormWrapper, StyleLabel } from "../style";
import { StyleTextArea, StyleTextAreaWrapper } from "./style";
import ErrorMessage from "../ErrorMessage";
interface TextAreaProps {
  name: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  label?: string;
  rows?: number;
  cols?: number;
  required?: boolean;
  styleInput?: string;
  styleLabel?: string;
  styleWrapper?: string;
  disabled?: boolean;
  minHeight?: number;
}
const TextArea: FC<TextAreaProps> = ({
  name,
  label,
  onChange,
  styleWrapper = "",
  styleLabel = "",
  minHeight,
  ...restProps
}) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const handleChange = ({ form, event }: any) => {
    const value = event.target.value;
    if (!!onChange) {
      onChange(value);
    } else {
      form.setFieldValue(name, value);
    }
  };
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error;
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleTextAreaWrapper>
              <StyleTextArea
                minHeight={minHeight}
                isFocus={isFocus}
                hasError={hasError}
                onChange={(event: ChangeEvent) => {
                  handleChange({
                    form,
                    event,
                  });
                }}
                value={field?.value || ""}
                onFocus={() => {
                  setIsFocus(true);
                }}
                onBlur={() => {
                  setIsFocus(false);
                }}
                {...restProps}
              />
            </StyleTextAreaWrapper>

            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        );
      }}
    </Field>
  );
};

export default TextArea;
